(function(angular){
	'use strict';
	
	angular.module('affixRevealModule', [
		'BaseConfig',
		'revealModule'
	]);

})(window.angular);